export default __webpack_public_path__ + "static/media/empty-user-image.bb480b2a.svg";